import React from 'react';
import * as PropTypes from 'prop-types';
import { BounceLoader } from 'react-spinners';

const CoolLoading = ({ color }) => (
  <BounceLoader color={color} size={160} css="margin: auto;" />
);

CoolLoading.defaultProps = {
  color: '#01372c',
};

CoolLoading.propTypes = {
  color: PropTypes.string,
};

export default CoolLoading;
